import { api1C } from './api';

export const get1cPriceTypes = (params) =>
    api1C.get('price-types', {
        params,
    });
